export default function Title({name}) {
    return <h1 className="room-name">{name}</h1>
}